export const urlCheckForPharos = () => {
    const url = window.location.href
    // You can set this to true if you want to see the hidden buttons that only
    // shows up in pharos.
    // setCurrentUrl(true);

    return (
        url.includes("pharos")
    )
}